import type { ChatsV2Translations } from '../interfaces/chatsV2';

export const chatsV2Translations: ChatsV2Translations = {
  page_title: 'Chats',

  inbox_all: 'Todos',
  inbox_mine: 'Atribuídos a mim',
  inbox_unread: 'Não lidos',
  inbox_handoff: 'Aguardando humano',
  inbox_closed: 'Fechados',

  channel_all: 'Todos os canais',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Web Chat',
  channel_messenger: 'Messenger',

  account_all_label: 'Todas as contas',
  account_select_label: 'Conta',

  search_placeholder: 'Buscar conversas, números, e-mails…',
  new_conversation: 'Nova conversa',
  toggle_context_show: 'Mostrar detalhes',
  toggle_context_hide: 'Ocultar detalhes',

  conversation_count: '{{count}} conversas',
  sort_recent: 'Recentes',
  sort_priority: 'Prioritárias',

  header_take_over: 'Assumir',
  header_auto_on: 'Auto',
  header_auto_off: 'Pausado',
  header_auto_paused_notice:
    'Resposta automática pausada. O agente não responderá. Qualquer mensagem sairá da sua conta.',
  header_resume: 'Retomar',

  composer_placeholder:
    'Escreva uma mensagem, ou use / para inserir um modelo…',
  composer_reply_as: 'Responder como:',
  composer_reply_as_human: 'humano',
  composer_reply_as_agent: 'agente',
  composer_send: 'Enviar',
  composer_outbound_via: 'Sairá por',
  composer_attach: 'Anexar',
  composer_window_expired_hint: "Já se passaram mais de 24 h desde a última mensagem do cliente. Você só pode enviar um modelo aprovado.",
  composer_window_never_hint: "O cliente ainda não escreveu. Para iniciar a conversa você precisa enviar um modelo aprovado.",
  composer_window_closing: "A janela de 24 h fecha em {{hours}} h",
  composer_send_template: "Enviar modelo",
  template_sent_notice: "Enviar um modelo não reabre a janela de 24 h — só uma resposta do cliente faz isso.",
  composer_templates: 'Modelos',
  composer_send_checkout: 'Enviar checkout',

  lead_score_label: 'Lead score',
  lead_hot: 'Hot',
  lead_warm: 'Warm',
  lead_cold: 'Cold',
  lead_score_intent: 'Intenção',
  lead_score_engagement: 'Engajamento',
  lead_score_budget: 'Orçamento',
  lead_score_urgency: 'Urgência',
  lead_score_pending: 'Análise pendente',
  data_collected_empty: 'Ainda não coletamos informações do lead',
  actions_empty: 'Nenhuma ação registrada',
  context_force_analyze: 'Forçar análise',
  context_analyzing: 'Analisando…',
  context_analyze_error: 'Não foi possível enfileirar a análise',
  context_empty_title: 'Selecione uma conversa',
  context_empty_description:
    'O detalhe do lead, as ações do agente e as notas internas aparecerão aqui quando você escolher um chat da lista.',
  send_failed: 'Não foi possível enviar a mensagem',
  composer_placeholder_locked:
    'Pause o agente para responder manualmente daqui',
  composer_locked_hint: 'O agente está respondendo automaticamente',
  header_pause_agent: 'Pausar agente',
  header_resume_agent: 'Retomar agente',
  header_paused_notice:
    'O agente está pausado. Suas mensagens sairão como humano até você retomar.',
  notes_save: 'Salvar nota',
  notes_saved: 'Nota salva',
  notes_save_error: 'Não foi possível salvar a nota',
  message_human_sent_by: 'Enviado por',
  system_event_human_takeover: 'O operador assumiu o controle',
  system_event_human_released: 'O operador devolveu o controle ao agente',
  system_event_handoff_triggered: 'O agente solicitou intervenção humana',
  system_event_agent_error: 'O agente falhou ao processar a mensagem',
  system_event_follow_up_dispatched: 'Follow-up automático enviado',
  system_event_conversation_closed: 'Conversa fechada',

  stage_label: 'Etapa',
  stage_contact: 'Contato',
  stage_qualified: 'Qualificado',
  stage_quote: 'Cotação',
  stage_close: 'Fechamento',

  data_collected_title: 'Dados coletados',
  data_collected_edit: 'Editar',
  actions_title: 'Ações do agente',
  notes_title: 'Notas internas',
  notes_placeholder: 'Visível apenas para a equipe…',

  context_action_profile: 'Perfil',
  context_action_tag: 'Etiqueta',
  context_action_close: 'Fechar',

  tab_lead: 'Lead',
  tab_history: 'Histórico',
  tab_actions: 'Ações',
  tab_history_placeholder: 'Histórico completo do cliente em breve.',
  tab_actions_placeholder: 'Ações rápidas em breve.',

  ai_suggestion_eyebrow: 'Sugestão do agente',
  ai_suggestion_apply: 'Aplicar',
  ai_suggestion_dismiss: 'Descartar',

  typing_label: 'está digitando…',
  today_pill: 'Hoje',
  empty_state_title: 'Selecione uma conversa',
  empty_state_description: 'Escolha um chat na lista para ver os detalhes.',
};
